export default {
  translation: {
    'Customer Information': '客戶資訊',
  },
};
